import React from "react";
import { useDataProvider } from "react-admin";
import { useForm, useFormState } from "react-final-form";

export const AutoSelectPalletsByPlace = ({ placeFieldName, onLoadingChange, targetFieldName = "pallet_ids" }) => {
	const dataProvider = useDataProvider();
	const form = useForm();
	const { values } = useFormState({ subscription: { values: true } });
	const placeId = values?.[placeFieldName];
	const lastPlaceIdRef = React.useRef(null);

	React.useEffect(() => {
		if (lastPlaceIdRef.current === placeId) {
			return;
		}

		lastPlaceIdRef.current = placeId;

		if (!placeId) {
			form.change(targetFieldName, []);
			return;
		}

		onLoadingChange?.(true);
		dataProvider
			.getOne("storage-places", { id: placeId })
			.then(({ data }) => {
				const entityIds = data?.state?.storage_entity_ids || [];
				if (!entityIds.length) {
					form.change(targetFieldName, []);
					return null;
				}

				return dataProvider.getList("storage-entities", {
					pagination: { page: 1, perPage: 100 },
					sort: { field: "id", order: "ASC" },
					filter: { storage_entity_ids: entityIds },
				});
			})
			.then((result) => {
				if (!result) return;
				const palletIds = (result.data || [])
					.map((item) => item.pallet_id)
					.filter(Boolean);
				form.change(targetFieldName, palletIds);
			})
			.catch(() => {
				form.change(targetFieldName, []);
			})
			.finally(() => {
				onLoadingChange?.(false);
			});
	}, [dataProvider, form, onLoadingChange, placeId, placeFieldName, targetFieldName]);

	return null;
};
